
export enum PredefinedAuthProvider {
    
    Passcode = "Passcode",
    Guest = "Guest",
    ApiKey = "ApiKey",

    Microsoft = "Microsoft",
    Google = "Google",
    LinkedIn = "LinkedIn",
    Facebook = "Facebook",
    GitHub = "GitHub",
    AnyEmail = "Any",

    Teams = "Teams"
}